<template>
<div>
    <div><h3>User Administration</h3></div>
    <div class="wrapper">
        <div class="row row-wider">
            <loader v-if="isLoading"/>
            <div class="col-md-12" id="divUserAdminSearch" v-show="isSearch">
                <div>
                    <h4>New Users (Setup Required)</h4>
                    <form @submit.prevent="" class="form-horizontal">
                        <div class="form-group">
                            <div class="col-md-2">
                                <label for="searchUsername">Username/Email</label>
                            </div>
                            <div class="col-md-4">
                                <input class="form-control" type="text" name="searchUsername" v-model="newUserSearchDto.username">
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-2">
                                <label for="searchFirstName">First Name</label>
                            </div>
                            <div class="col-md-3">
                                <input class="form-control" type="text" name="searchFirstName" v-model="newUserSearchDto.firstName">
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-2">
                                <label for="searchLastName">Last Name</label>
                            </div>
                            <div class="col-md-3">
                                <input class="form-control" type="text" name="searchLastName" v-model="newUserSearchDto.lastName">
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-2">
                                <button class="btn btn-primary" name="button" v-on:click="searchNewUser">Search</button>
                            </div>
                        </div>
                    </form>
                    <v-client-table :data="newUserList" :columns="userGridSpec.columnsNew" :options="userGridSpec.options">
                        <template slot="edit" slot-scope="props">
                            <div style="text-align: center">
                                <a  class="fa fa-edit" style="font-size: 18px;" v-on:click="editUser(props.row)"></a>
                            </div>
                        </template>
                        <template slot="delete" slot-scope="props">
                            <div style="text-align: center">
                                <a  class="fa fa-ban" style="font-size: 18px;" v-on:click="deleteUser(props.row)"></a>
                            </div>
                        </template>
                    </v-client-table>
                </div>
                <div><hr class="spacer "/></div>
                <div>
                    <h4>All Users</h4>
                    <form @submit.prevent="" class="form-horizontal">
                        <div class="form-group">
                            <div class="col-md-2">
                                <label for="searchUsername">Username/Email</label>
                            </div>
                            <div class="col-md-4">
                                <input class="form-control" type="text" name="searchUsername" v-model="allUserSearchDto.username">
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-2">
                                <label for="searchFirstName">First Name</label>
                            </div>
                            <div class="col-md-3">
                                <input class="form-control" type="text" name="searchFirstName" v-model="allUserSearchDto.firstName">
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-2">
                                <label for="searchLastName">Last Name</label>
                            </div>
                            <div class="col-md-3">
                                <input class="form-control" type="text" name="searchLastName" v-model="allUserSearchDto.lastName">
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-md-2">
                                <button class="btn btn-primary" name="button" v-on:click="searchUser">Search</button>
                            </div>
                        </div>
                    </form>
                    <v-client-table :data="userGridSpec.tableData" :columns="userGridSpec.columns" :options="userGridSpec.options">
                        <template slot="edit" slot-scope="props">
                            <div style="text-align: center">
                                <a  class="fa fa-edit" style="font-size: 18px;" v-on:click="editUser(props.row)"></a>
                            </div>
                        </template>
                    </v-client-table>
                    <!-- <button class="btn btn-primary pull-right" v-on:click="clearUser()">Add New</button> -->
                </div>
            </div>
            <div class="col-md-12" id="divUserAdminEdit" v-show="!isSearch">
                <h4>Edit User</h4>
                <form v-on:submit.prevent class="form form-horizontal" data-vv-scope="editUser" ref="editForm">
                    <div class="form-group">
                        <label class="col-md-3 control-label">Username/Email</label>
                        <div class="col-md-4">
                            <input type="text" class="form-control" v-model="user.name" placeholder="Email Address">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">Auth0 Method</label>
                        <div class="col-md-4">
                            <label class="control-label">{{user.auth0Method}}</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">First Name</label>
                        <div class="col-md-4">
                            <input type="text" class="form-control" v-model="user.firstName" placeholder="First Name">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">Last Name</label>
                        <div class="col-md-4">
                            <input type="text" class="form-control" v-model="user.lastName" placeholder="Last Name">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">Phone Number</label>
                        <div class="col-md-4">
                            <input type="text" class="form-control" v-model="user.phone" placeholder="Phone Number">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-3 control-label">User Organizations</label>
                        <div class="col-md-7">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Organization Name</th>
                                        <th>Primary</th>
                                        <th>Remove</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in user.userOrganization" v-bind:key="item.userOrganizationId">
                                        <td>{{item.description}}</td>
                                        <td>{{item.isPrimary ? "Yes" : "No"}}</td>
                                        <td><a class="fa fa-ban" style="font-size: 18px;" v-on:click="removeOrganization(index)"></a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-1 col-md-offset-3">
                            <button class="form-contol btn" v-on:click="$refs['organizationModal'].open()">Add Organization</button>
                        </div>
                    </div>
                    <div class="form-group" >
                        <label class="col-md-3 control-label">User Roles</label>
                        <div class="col-md-7">
                            <div v-for="role in roleList" v-bind:key="role.roleId" class="checkbox checkbox-inline">
                                <input type="checkbox" v-model="roleSelectedList" :id="role.roleId" :value="role.roleId">
                                    <label v-bind:for="role.roleId">{{ role.description}}</label>
                                </input>   
                            </div>
                        </div>                       
                    </div>
                    <modal ref="organizationModal">
                        <div slot="header" class="row">
                            <h3 class="pull-left">Add User Organization</h3>
                            <button class="btn pull-right" v-on:click="$refs['organizationModal'].close()">X</button>
                        </div>
                        <div slot="body">
                            <div class="form form-horizontal">
                                <div class="form-group">
                                    <label class="col-md-3 control-label">Organization</label>
                                    <div class="col-md-6">
                                        <select class="form-control" v-model="userOrganizationDto.organizationId">
                                            <option disabled :value="null">Select An Organization</option>
                                            <option v-for="org in organizationList" v-bind:key="org.organizationId" :value="org.organizationId">{{org.description}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-3 control-label">Is Primary</label>
                                    <div class="col-md-4">
                                        <div class="checkbox checkbox-inline">
                                            <input id="orgIsPrimaryCB" type="checkbox" v-model="userOrganizationDto.isPrimary">
                                                <label for="orgIsPrimaryCB"></label>
                                            </input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div slot="footer">
                            <div class="row">
                                <button :disabled="userOrganizationDto.organizationId == null" name="buttonDone" class="btn btn-primary col-md-3" v-on:click="addOrganization()">Add</button>
                            </div>
                        </div>
                    </modal>
                    <div class="form-group">
                        <div class="col-md-2">
                            <button class="btn btn-primary pull-left" v-on:click="backToSearch">Back</button>
                        </div>
                        <div class="col-md-2">
                            <button class="btn btn-primary pull-left" v-on:click="saveUser">Save</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import userService from '@/services/userService'
import roleService from '@/services/roleService'
import loggingService from '@/services/util/loggingService'
import organizationService from '@/services/organizationService'

import loader from '@/components/Loader'
import modal from '@/components/Modal.vue'

export default {
    components: {
        loader,
        modal
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            user: {},
            userOrganizationDto: {
                organizationId: null,
                description: '',
                isPrimary: false
            },
            organizationList: [],
            roleList: [],
            roleSelectedList: [],
            userGridSpec: {
                columns: ['edit', 'name', 'auth0Method', 'firstName', 'lastName', 'phone', 'orgName'],
                columnsNew: ['edit', 'name', 'auth0Method', 'firstName', 'lastName', 'phone', 'orgName', 'delete'],
                options: {
                    perPage: 10,
                    perPageValues: [5, 10, 25],
                    headings: {
                        edit: 'View/Edit',
                        name: 'Username',
                        description: 'User Email',
                        firstName: 'First Name',
                        lastName: 'Last Name',
                        phone: 'Phone Number',
                        orgName: 'Organization',
                        auth0Method: 'Auth0 Method'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'name'
                    }
                },
                tableData: []
            },
            newUserList: [],
            allUserSearchDto: {},
            newUserSearchDto: {},
            isSearch: true
        }
    },
    mounted () {
        this.loadData()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Organization', message)
        },
        loadData () {
            this.isLoading = true
            userService.listAllUserResultDtos(this.$http).then(result => {
                this.userGridSpec.tableData = result.data.objectList[0]
                this.newUserList = result.data.objectList[0].filter(x => { return !x.userRole || x.userRole.length === 0 })
                //get organization name
                this.parseTableOrgAndRoleNames(this.userGridSpec.tableData)
                this.parseTableOrgAndRoleNames(this.newUserList)
                this.loadLookups()
                //get user if userId query exists
                if (this.$route.query.userId) {
                    console.log(this.userGridSpec.tableData)
                    var user = this.userGridSpec.tableData.find(x => x.userId === Number(this.$route.query.userId))
                    if (user) {
                        this.editUser(user)
                    }
                }
                this.isLoading = false
            })
        },
        loadLookups () {
            organizationService.list(this.$http).then(result => {
                this.organizationList = result.data
            })
            roleService.list(this.$http).then(result => {
                this.roleList = result.data
            })
        },
        editUser (user) {
            this.user = user
            this.roleSelectedList = user.userRole.map(x => {
                return x.roleId
            })
            this.isSearch = false
        },
        clearUser () {
            this.user = {}
            this.clearUserOrg()
            this.roleSelectedList = []
        },
        saveUser () {
            this.$validator.validateAll('editUser').then(result => {
                if (result) {
                    //compile user roles
                    this.user.userRole = this.roleSelectedList.map(role => {
                        return {
                            userId: this.user.userId || 0,
                            roleId: role
                        }
                    })
                    userService.put(this.$http, this.user).then(result => {
                        this.$router.go()
                    })
                }
            })
        },
        clearUserOrg () {
            this.userOrganizationDto = {
                organizationId: null,
                description: '',
                isPrimary: false
            }
        },
        addOrganization () {
            this.userOrganizationDto.description = this.organizationList.find(x => { return x.organizationId === this.userOrganizationDto.organizationId }).description
            this.user.userOrganization.push(this.userOrganizationDto)
            this.clearUserOrg()
            this.$refs['organizationModal'].close()
        },
        removeOrganization (index) {
            this.user.userOrganization.splice(index, 1)
        },
        deleteUser (user) {
            if (confirm(`Are you sure you want to delete this user: ${user.name}?`)) {
                userService.deleteNewUser(this.$http, user.userId).then(r => {
                    this.$router.go()
                })
            }
        },
        searchUser () {
            this.isLoading = true
            userService.searchUserResultDtos(this.$http, this.allUserSearchDto).then(result => {
                this.userGridSpec.tableData = result.data.objectList[0]
                this.parseTableOrgAndRoleNames(this.userGridSpec.tableData)
                this.isLoading = false
            })
        },
        searchNewUser () {
            this.isLoading = true
            userService.searchUserResultDtos(this.$http, this.newUserSearchDto).then(result => {
                this.newUserList = result.data.objectList[0].filter(x => { return !x.userRole || x.userRole.length === 0 })
                this.parseTableOrgAndRoleNames(this.newUserList)
                this.isLoading = false
            })
        },
        parseTableOrgAndRoleNames (tableData) {
            tableData.forEach(user => {
                user.orgName = (user.userOrganization[0] || {description: ''}).description
                user.roleName = (user.userRole[0] || {roleName: ''}).roleName
            })
        },
        backToSearch () {
            this.isSearch = true
        }
    }
}
</script>



// WEBPACK FOOTER //
// UserAdministration.vue?430ef6e8